import { render, staticRenderFns } from "./AlipayInvoke.vue?vue&type=template&id=1ebbf088&scoped=true&"
import script from "./AlipayInvoke.vue?vue&type=script&lang=js&"
export * from "./AlipayInvoke.vue?vue&type=script&lang=js&"
import style0 from "./AlipayInvoke.vue?vue&type=style&index=0&id=1ebbf088&prod&lang=css&"
import style1 from "./AlipayInvoke.vue?vue&type=style&index=1&id=1ebbf088&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebbf088",
  null
  
)

export default component.exports